import React from "react";
import { useTranslation } from "react-i18next";

function LanguageSwitcher() {
  const { i18n } = useTranslation();

  return (
      <div className="euiFormControlLayout " style={{maxWidth:"100px", marginLeft:"10px"}}>
        <div className="euiFormControlLayout__childrenWrapper">
          <select id="selectDocExample" className="euiSelect"  style={{padding:"0px", paddingLeft:"10px"}}
              value={i18n.language} onChange={(e) =>
                i18n.changeLanguage(e.target.value)
              }>
            <option value="en">English</option>
            <option value="hr">Hrvatski</option>
            <option value="sl">Slovenski</option>
          </select>
        </div>
      </div>
  );
}


export default LanguageSwitcher;

